/**
 * PAEX nav label decorator — renders the merchant convention "Title|LABEL"
 * (typed in the Shopify navigation editor) as a colored bubble next to the
 * item, in NATIVE-rendered menu areas (desktop dropdown/mega columns, star
 * col, drawer levels). paex-rendered surfaces do the same server-side via
 * snippets/paex-nav-label.liquid. Loaded (deferred) by sections/header.liquid
 * when the "Nav label bubbles" theme setting is on.
 *
 * Scope discipline:
 * - Only inside hidden-at-load surfaces (.header-submenu panels + the drawer)
 *   — never the always-visible desktop first-level row, which would shift
 *   layout after paint (use Ascent's native bubble block for L1 accents).
 * - Only menu TITLE containers — never product/article card titles, which
 *   may legitimately contain pipes ("6ft Banner | Gold").
 * - First-pipe semantics, one pipe per title (matches paex-nav-label.liquid
 *   and the approved prototype).
 * - Text nodes only (existing carets/bubbles/media survive); badge styles
 *   injected once (kept in sync with .paex-nav-badge in paex-mega-seasonal.css).
 */

(function () {
  'use strict';

  var STYLE_ID = 'paex-nav-badge-style';
  var SCOPES = '.header-submenu, .menu-drawer-nav';
  var TITLE_CONTAINERS =
    '.link, .link-text, .mega-star-text, .list-menu-title__text, .menu-title';
  var EXCLUDED =
    '.paex-nav-badge, .paex-mega-pl, .paex-swipe, .featured-card, .card-product, product-card';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.paex-nav-badge{display:inline-flex;align-items:center;margin-inline-start:6px;' +
      'font-size:10.5px;font-weight:900;letter-spacing:.04em;line-height:1.4;' +
      'padding:2px 6px;border-radius:5px;white-space:nowrap;background:#d61f69;color:#fff}' +
      '.paex-nav-badge--new{background:#ffd52e;color:#1e1b2e}' +
      '.paex-nav-badge--hot,.paex-nav-badge--sale{background:#d61f2b;color:#fff}';
    document.head.appendChild(style);
  }

  function badgeFor(raw) {
    var text = raw.trim();
    var key = text.toUpperCase();
    var span = document.createElement('span');
    span.className = 'paex-nav-badge';
    // NOUVEAU = the French NEW (translated link titles): same yellow badge.
    if (key === 'NEW' || key === 'NOUVEAU') span.className += ' paex-nav-badge--new';
    else if (key === 'HOT') span.className += ' paex-nav-badge--hot';
    else if (key === 'SALE') span.className += ' paex-nav-badge--sale';
    if (key === 'HOT') {
      var flame = document.createElement('span');
      flame.setAttribute('aria-hidden', 'true');
      flame.textContent = '🔥 ';
      span.appendChild(flame);
    }
    span.appendChild(document.createTextNode(text));
    return span;
  }

  function decorateTextNode(node) {
    var parts = node.nodeValue.split('|');
    if (parts.length < 2) return;
    var badge = parts[1].trim();
    if (!badge) return;
    node.nodeValue = parts[0].replace(/\s+$/, '');
    node.parentNode.insertBefore(badgeFor(badge), node.nextSibling);
  }

  function decorate(root) {
    root.querySelectorAll(SCOPES).forEach(function (scope) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue || node.nodeValue.indexOf('|') === -1) {
            return NodeFilter.FILTER_REJECT;
          }
          var parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          if (!parent.closest(TITLE_CONTAINERS)) return NodeFilter.FILTER_REJECT;
          if (parent.closest(EXCLUDED)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(decorateTextNode);

      // Native aria-labels are built from raw titles ("Submenu for X|HOT") —
      // strip the token there too (the scope element itself carries one on
      // desktop panels).
      var labelled = Array.prototype.slice.call(
        scope.querySelectorAll('[aria-label*="|"]')
      );
      if ((scope.getAttribute('aria-label') || '').indexOf('|') !== -1) {
        labelled.push(scope);
      }
      labelled.forEach(function (element) {
        element.setAttribute(
          'aria-label',
          element.getAttribute('aria-label').split('|')[0].replace(/\s+$/, '')
        );
      });
    });
  }

  function run() {
    ensureStyles();
    decorate(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    ensureStyles();
    decorate(event.target || document);
  });
})();
